export enum WebSocketMessageType {
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
  BROADCAST = 'BROADCAST',
  FROM_CLIENT = 'FROM_CLIENT',
  SERVER_ERROR = 'SERVER_ERROR',
  HEARTBEAT = 'HEARTBEAT',
}
